import React, { useState, useEffect, createContext, useContext } from 'react'

// create the context object with a default value of an empty object
const WindowSizeContext = createContext({})

// now create the provider component where we will set our logic for the 
// WindowSizeContext. using useState and useEffect we can set the width and height
// values using the window.width/ height properties when the window is resized
function WindowSizeProvider(props) { // grab all the props
    // using useState create the variables/ setters for our width and height
    // initially sete to the windows current width and height
    const [width, setWidth] = useState(window.innerWidth)
    const [height, setHeight] = useState(window.innerHeight)

    // create a callback function to set the width and height when the window is resized
    const handleResize = ev => {
        setWidth(window.innerWidth)
        setHeight(window.innerHeight)
    }

    // now using the useEffect hook we can add an event listner to fire the callback
    // function and return a cleanup function to remove the event listener on exit
    useEffect(() => {
        window.addEventListener('resize', handleResize)

        // cleanup functions are returned when using react hooks
        return () => window.removeEventListener('resize', handleResize)
    }, []) // supplying an empty depandancy array 

    // now return the WindowSizeContext.Provider jsx element with its value
    // being an object containing the width and height (using json shorthand for width: width)
    // and return its props unchanged
    return (
        <WindowSizeContext.Provider value={{ width, height }}
            {...props}
        />
    )
}

// a useWindowSize hook that will provide any child components of the context provider
// with the width and height values of the users window viewport
function useWindowSize() {
    // check if the hook is being called inside the Context Provider, if not throw an error 
    const context = useContext(WindowSizeContext)
    if (!context) throw new Error('useWindowSize hook must be called within a WindowSizeProvider')

    // get the width and height from the context provider 
    // above using json destructing and return an object containing the values
    const { width, height } = context
    return { width, height }
}

// export the WindowSizeProvider and the useWindowSize hook
export { WindowSizeProvider, useWindowSize }